module.exports = __webpack_public_path__ + "static/Merge-7404a6673527659b8bc78a87edae1e6f.jpg";